const $$splitComponentImporter = () => import('/app/src/routes/subscription/pay.$token.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { parseOutcome } from "@/lib/payment-return-url";

// The emailed pay link. `?status=` is the legacy Monri return (forms opened
// before the path-based `/subscription/pay/<token>/<outcome>`); Monri glues its
// own params onto it with a second `?`, which parseOutcome cuts off.
export const Route = createFileRoute("/subscription/pay/$token")({
  validateSearch: (search: Record<string, unknown>) => ({
    status: parseOutcome(search.status)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});